import loc, { format } from 'owa-localize';
import {
    replyByImLabel,
    replyAllRecipientsByImLabel,
    replyByImDefaultLabel,
    replyAllParticipantsByImLabel,
    replyByImWin32Label,
    replyAllByImWin32Label,
} from '../teams-integration.locstring.json';
import { isMeetingRequest } from 'owa-meeting-message-utils/lib/utils/isMeetingRequest';
import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';

export function getReplyByIMDisplayName(name?: string): string {
    if (isWin32StylingEnabled()) {
        return loc(replyByImWin32Label);
    }

    if (!!name) {
        return format(loc(replyByImLabel), name);
    } else {
        return loc(replyByImDefaultLabel);
    }
}

export function getReplyAllByIMDisplayName(itemClass?: string): string {
    if (isWin32StylingEnabled()) {
        return loc(replyAllByImWin32Label);
    }

    return isMeetingRequest(itemClass)
        ? loc(replyAllParticipantsByImLabel)
        : loc(replyAllRecipientsByImLabel);
}
